import { useEffect, useState } from 'react';

import { Placeholder } from 'components';
import { getPrivacy } from 'services';
import { PrivacyInterface } from 'types';

import './style.scss';

export default function PrivacyPage() {
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<PrivacyInterface>();

  useEffect(() => {
    getPrivacy()
      .then(_data => setData(_data))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div id="privacy">
        <div className="grid gap-4">
          <Placeholder className="w-full" />
          <Placeholder className="w-3/4" />
          <Placeholder className="w-full" />
          <Placeholder className="w-3/4" />
          <Placeholder className="w-full" />
          <Placeholder className="w-3/4" />
          <Placeholder className="w-full" />
          <Placeholder className="w-full" />
          <Placeholder className="w-full" />
          <Placeholder className="w-3/4" />
          <Placeholder className="w-full" />
          <Placeholder className="w-full" />
        </div>
      </div>
    );
  }

  return (
    <section id="privacy">
      <h2 className="text-xl lg:text-3xl mb-5 lg:mb-8">Política de privacidade</h2>

      <div className="content" dangerouslySetInnerHTML={{ __html: data?.content || '' }} />
    </section>
  );
}
